import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { obtenerDetalleProyecto, limpiarDetalleProyecto } from '../../actions/proyectos';

import CotizacionesProyecto from './cotizaciones/CotizacionesProyecto';
import ConceptosProyecto from './conceptos/ConceptosProyecto';
import OrdenesSalidaProyecto from './ordenes/OrdenesSalidaProyecto';
import OrdenesDevolucionProyecto from './devoluciones/OrdenesDevolucionProyecto';
import PagosProyecto from './pagos/PagosProyecto';
import ResumenProyecto from './resumen/ResumenProyecto';

const formatDate = (value) => {
    if (!value) return 'Sin definir';
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    return d.toLocaleDateString('es-MX');
};

const DetalleProyecto = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { detalle: proyecto, loadingDetalle } = useSelector(state => state.proyectos);

    const [tabActiva, setTabActiva] = useState(0);

    useEffect(() => {
        if (!id) return;

        dispatch(obtenerDetalleProyecto(id));

        return () => {
            dispatch(limpiarDetalleProyecto());
        };
    }, [dispatch, id]);

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { activo: false, nombre: 'Proyectos', path: '/proyectos' },
            { activo: true, nombre: proyecto?.nombre || 'Detalle de proyecto', path: `/proyectos/detalle/${id}` }
        ]));
    }, [dispatch, id, proyecto]);

    if (loadingDetalle || !proyecto) {
        return (
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Cargando proyecto...</h3>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5 mb-1">{proyecto?.nombre || 'Sin definir'}</h3>
                    <h6 className="text-muted mb-4">{proyecto?.cliente?.nombre || 'Sin cliente'}</h6>

                    <div className="row mb-4">
                        <div className="col-md-3">
                            <div className="text-muted small">Fecha inicio tentativa</div>
                            <div>{formatDate(proyecto?.fecha_inicio_tentativa)}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small">Fecha fin tentativa</div>
                            <div>{formatDate(proyecto?.fecha_fin_tentativa)}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small">Fecha inicio real</div>
                            <div>{formatDate(proyecto?.fecha_inicio_real)}</div>
                        </div>
                        <div className="col-md-3">
                            <div className="text-muted small">Fecha fin real</div>
                            <div>{formatDate(proyecto?.fecha_fin_real)}</div>
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="text-muted small">Descripción</div>
                        <div>{proyecto?.descripcion || 'Sin definir'}</div>
                    </div>

                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 0 ? ' active' : ''}`}
                                onClick={() => setTabActiva(0)}
                            >
                                Resumen
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 1 ? ' active' : ''}`}
                                onClick={() => setTabActiva(1)}
                            >
                                Cotizaciones
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 2 ? ' active' : ''}`}
                                onClick={() => setTabActiva(2)}
                            >
                                Conceptos externos
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 3 ? ' active' : ''}`}
                                onClick={() => setTabActiva(3)}
                            >
                                Ordenes de salida
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 4 ? ' active' : ''}`}
                                onClick={() => setTabActiva(4)}
                            >
                                Ordenes de devolución
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 5 ? ' active' : ''}`}
                                onClick={() => setTabActiva(5)}
                            >
                                Pagos
                            </button>
                        </li>
                    </ul>

                    {tabActiva === 0 && (
                        <ResumenProyecto idProyecto={id} />
                    )}

                    {tabActiva === 1 && (
                        <CotizacionesProyecto idProyecto={id} />
                    )}

                    {tabActiva === 2 && (
                        <ConceptosProyecto idProyecto={id} />
                    )}

                    {tabActiva === 3 && (
                        <OrdenesSalidaProyecto idProyecto={id} />
                    )}

                    {tabActiva === 4 && (
                        <OrdenesDevolucionProyecto idProyecto={id} />
                    )}

                    {tabActiva === 5 && (
                        <PagosProyecto idProyecto={id} />
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default DetalleProyecto;
